var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 14,
    viewBox: "0 0 49 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78879 0.916672L0.333984 13.0677H6.86415L7.67371 11.1303H9.52416L10.3337 13.0677H17.5216V11.589L18.1621 13.0677H21.8802L22.5207 11.5578V13.0677H37.4695L39.2872 11.1806L40.9893 13.0677L48.6673 13.0833L43.1953 7.02611L48.6673 0.916672H41.1084L39.3389 2.76887L37.6905 0.916672H21.4281L20.0317 4.05296L18.6024 0.916672H12.0859V2.34503L11.361 0.916672H5.78879ZM28.1115 2.64215H36.6958L39.3214 5.49696L42.0316 2.64215H44.6571L40.6678 7.02442L44.6571 11.3562H41.9125L39.2869 8.46821L36.5629 11.3562H28.1115V2.64215ZM30.2314 6.03909V4.44741V4.44589H35.5878L37.925 6.9914L35.4842 9.55081H30.2314V7.81315H34.9146V6.03909H30.2314ZM7.05235 2.64215H10.2355L13.8536 10.8818V2.64215H17.3406L20.1352 8.54997L22.7108 2.64215H26.1803V11.3613H24.0692L24.052 4.52903L20.9741 11.3613H19.0856L15.9905 4.52903V11.3613H11.6474L10.8241 9.4066H6.3757L5.55403 11.3596H3.22705L7.05235 2.64215ZM7.13574 7.59959L8.6013 4.11741L10.0652 7.59959H7.13574Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmex);
export default __webpack_public_path__ + "static/media/amex.3fdaae8c64efca5f0b20892418fb10a0.svg";
export { ForwardRef as ReactComponent };